// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2CcIq","cell":"ColumnAccessor_cell__24js3","firstCellAccent":"ColumnAccessor_firstCellAccent__1GK1g"};